import { faFileCsv } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Tooltip } from "@mui/material";
import React, { } from "react";
import { useCallback } from "react";
import { exportColor, iconSize } from "../App/GridRenderers";
import { GoogleAnalyticsEvent } from "./ga4";


export const GridCsv = ({ gridRefFn = null, filename = "export", name, scenario, client, dataset }) => {

    const onCsvDownload = useCallback(() => {
        let gridRef = gridRefFn()
        if (gridRef !== null && gridRef.current !== null) {
            gridRef.current.api.exportDataAsCsv({
                fileName: filename + ".csv",
                prependContent: "MyOwnFP " + name + "\r\n" + scenario + "\r\n" + client + "\r" + dataset,
                allColumns: false,
            })
            GoogleAnalyticsEvent("csv", "grid", "scenario", { action: "download", type: "scenario" })
        }
    }, [gridRefFn])

    return (
        (gridRefFn !== null && gridRefFn() !== null &&
            <Box sx={{ pt: 1 }}>
                <Tooltip title="Download a CSV file  of the grid"
                    enterDelay={1000}>
                    <FontAwesomeIcon
                        icon={faFileCsv}
                        onClick={onCsvDownload}
                        // size="xl"
                        size={iconSize}
                        color={exportColor}

                    />
                </Tooltip>
            </Box>
        )
    )

}


